export function formatNumber(value: string | number): string {
  const num = typeof value === 'string' ? parseInt(value, 10) : value
  return new Intl.NumberFormat().format(num)
}

export function formatAddress(address: string): string {
  if (!address) return ''
  const start = address.slice(0, 6)
  const end = address.slice(-4)
  return `${start}...${end}`
}

export function formatDigest(digest: string): string {
  if (!digest) return ''
  const start = digest.slice(0, 8)
  const end = digest.slice(-6)
  return `${start}...${end}`
}

export function formatBalance(balance: string | number, decimals = 9): string {
  const num = typeof balance === 'string' ? parseInt(balance, 10) : balance
  const value = num / Math.pow(10, decimals)
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value)
}

export function formatBalanceInSUI(balance: number): string {
	return new Intl.NumberFormat("en-US", { maximumSignificantDigits: 10 }).format(balance / 1_000_000_000)
}
export function formatBalanceInMIST(balance: number): string {
	return balance.toLocaleString();
}

export function formatUnixTimestamp(date: number): string {
	const dtf = new Intl.DateTimeFormat('en-US', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
		timeZone: 'UTC',
		// Though we request a timeZoneName, we can ignore the value later and hardcode "UTC"
		timeZoneName: 'short'
	});

  const parts = dtf.formatToParts(date);
	const data: any = {};
	parts.forEach(({ type, value }) => {
		data[type] = value;
	});

	return `${data.year}-${data.month}-${data.day} ${data.hour}:${data.minute}:${data.second} UTC`;
}

export function formatGas(gas: string | number): string {
  return formatBalance(gas, 9) + ' SUI'
}

export function formatPercentage(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatDuration(ms: number): string {
  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days > 0) return `${days}d`
  if (hours > 0) return `${hours}h`
  if (minutes > 0) return `${minutes}m`
  return `${seconds}s`
}
